function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import request from "superagent";
import { keyValueArrayToObject, getJsonConfig } from "../../utils/utils.js";
import Form from "../forms/Form";
import { adaptiveUrl, gmSessionId } from "../../init";

var dataTypeDict = {
  "dee25205-d3a3-42a5-870f-8d673491b2cf": "text",
  "4d2ff201-1757-4133-aeda-ea5217c1d6f6": "boolean",
  "404c8d64-3727-476f-8631-3fbd03ca738b": "integer",
  "61980343-edc4-4acc-be16-c313711b9fd4": "decimal",
  "63fe55ef-0a0b-47c3-9027-d98ad885d1f1": "text_area",
  "154627bd-2b5e-4ecb-97ef-c4af7d3e01c6": "date",
  "4b9a1fb5-c35f-472e-a4d7-176f4ceaa290": "list",
  "3386dc9b-6143-4cba-8c38-d8b4a96d0bdc": "multiselect_list",
  "41becc03-4c9a-4587-8291-2e50b20e9d5b": "editable_list",
  "2a76ddc3-2d32-4476-82ae-58ce06dd5652": "datetime",
  "521e4fed-87f5-4cfa-9911-94f98afcb708": "serial",
  "76c2a3d6-4e46-4d23-b444-256fc2c8bd5a": "media",
  "92f9c7c3-90b3-41f9-bb4b-e37cc681db68": "url",
  "70a9e6e4-665b-405b-8bf9-75d5ad149d89": "dictionary",
  "ab306a41-79c3-44b3-ba59-0791be20889f": "multiselect_dictionary",
  "fcd7139f-06ac-4526-a7a9-48dfe3de3463": "geometry",
  "bc8e073b-12bd-42c3-b087-1ea3b5472e5f": "uuid[]"
};

var dataTypeFieldTypeDict = {
  text: "textField",
  boolean: "booleanField",
  integer: "integerField",
  decimal: "decimalField",
  text_area: "textAreaField",
  date: "dateField",
  list: "listField",
  multiselect_list: "multiselectListField",
  editable_list: "editableListField",
  datetime: "datetimeField",
  serial: "integerField",
  media: "singleMediaField",
  url: "urlField",
  dictionary: "dictionaryField",
  multiselect_dictionary: "multiselectDictionaryField",
  geometry: "geometryField",
  "uuid[]": "uuidArrayField"
};

var spatialDataTypeDict = {
  "3a801bfc-4b55-45a4-867f-bc5c3a4bfb5a": "point",
  "c193d4c9-2251-4324-bc50-2e6f5f13d020": "line",
  "1b748207-9817-4c2a-b0b9-f2f1f84d7450": "polygon",
  "3b644e43-791b-4905-bd95-6f5d99eb0ec2": "no_geom",
  "14a13022-ac6c-49a5-b01b-9498800d423f": "multipoint",
  "756e6bfd-2903-42a0-98e1-faf52709326f": "multiline",
  "6879a2e2-31e7-4587-ac25-148629ce5188": "multipolygon"
};

var fixDate = function fixDate(date) {
  if (date) {
    if (typeof date == "string") {
      if (date.indexOf("/Date(") == 0) {
        date = date.replace("/Date(", "");
        date = date.replace(")/", "");

        return new Date(parseInt(date) || date);
      } else {
        return new Date(date);
      }
    } else {
      return date;
    }
  } else {
    return date;
  }
};

var DigiThemeForm = function (_Component) {
  _inherits(DigiThemeForm, _Component);

  function DigiThemeForm(props) {
    _classCallCheck(this, DigiThemeForm);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {};


    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleCancel = _this.handleCancel.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  DigiThemeForm.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var record = this.props.record;

    if (record && prevProps.record != record && record.uuid) {
      //this.loadMedia(record.uuid, themeUuid);
    }
  };

  DigiThemeForm.prototype.handleChange = function handleChange(name, value, invalid, dirty) {
    var onChange = this.props.onChange;

    var formattedValue = this.formatColumnValue(name, value);
    onChange && onChange(name, formattedValue, invalid, dirty);
  };

  DigiThemeForm.prototype.formatColumnValue = function formatColumnValue(name, fieldValue) {
    var columns = this.props.digiTheme.columns;

    var currentColumn = columns.find(function (c) {
      return c.column_name === name;
    });
    if (!currentColumn) {
      return fieldValue;
    }

    var dataType = dataTypeDict[currentColumn.data_type];
    switch (dataType) {
      case "multiselect_list":
      case "multiselect_dictionary":
        fieldValue = fieldValue && fieldValue.join(",") || null;
        break;
      case "date":
        fieldValue = fieldValue && fieldValue.toISOString() || null;
        break;
      case "boolean":
        fieldValue = fieldValue === null ? null : fieldValue && fieldValue === "t";
        break;
      default:
        fieldValue = fieldValue;
        break;
    }
    return fieldValue;
  };

  DigiThemeForm.prototype.handleSave = function handleSave(values) {
    var _props = this.props,
        digiTheme = _props.digiTheme,
        onSave = _props.onSave;

    if (!onSave) return;

    var columns = digiTheme.columns;

    var reduced = Object.keys(values).reduce(function (rec, key) {
      var fieldValue = values[key].value;
      var currentColumn = columns.find(function (c) {
        return c.column_name === key;
      });
      if (!currentColumn) {
        return rec;
      }

      if (key === "geom_wkt") {
        var geomCol = values["geom_wkt"];
        rec[key] = geomCol.value;
        rec["geom_modified"] = !!geomCol.dirty;
        return rec;
      }

      var dataType = dataTypeDict[currentColumn.data_type];
      switch (dataType) {
        case "multiselect_list":
        case "multiselect_dictionary":
          rec[key] = fieldValue && fieldValue.join(",") || null;
          break;
        case "date":
          rec[key] = fieldValue && fieldValue.toISOString() || null;
          break;
        case "boolean":
          rec[key] = fieldValue === null ? null : fieldValue && fieldValue === "t";
          break;
        default:
          rec[key] = fieldValue;
          break;
      }
      return rec;
    }, {});

    onSave(reduced);
  };

  DigiThemeForm.prototype.handleCancel = function handleCancel(dirtyColumns) {
    var onCancel = this.props.onCancel;

    onCancel && onCancel(dirtyColumns);
  };

  DigiThemeForm.formatRecordValues = function formatRecordValues(record, columns) {
    var reduced = Object.keys(record).reduce(function (rec, key) {
      if (key === "geom_wkt") {
        rec[key] = record[key];
        return rec;
      }
      var currentColumn = columns.find(function (c) {
        return c.column_name === key;
      });
      if (!currentColumn) {
        return rec;
      }

      var columnValue = record[key];
      var dataType = dataTypeDict[currentColumn.data_type];
      switch (dataType) {
        case "multiselect_dictionary":
          rec[key] = columnValue && columnValue.split(",").map(function (item) {
            return parseInt(item);
          });
          break;
        case "multiselect_list":
          rec[key] = columnValue && columnValue.split(",");
          break;
        case "datetime":
        case "date":
          rec[key] = fixDate(columnValue);
          break;
        case "boolean":
          rec[key] = typeof columnValue === "boolean" ? columnValue && "t" || "f" : null;
          break;
        case "dictionary":
          rec[key] = columnValue;
        default:
          rec[key] = columnValue;
          break;
      }
      return rec;
    }, {});

    return reduced;
  };

  DigiThemeForm.prototype.loadMedia = function loadMedia(recordUuid, themeUuid) {
    return request.post(adaptiveUrl() + "WebServices/generic/Media.asmx/Read").send({
      parent_object_uuid: themeUuid,
      start: 0,
      limit: 25,
      extraParams: [{
        key: "parent_object_uuid",
        value: themeUuid
      }],
      filter: {
        greedy: true,
        filterColumns: [{
          name: "uuid",
          value: recordUuid,
          comparisonOperator: "=",
          logicalOperator: "AND"
        }, {
          name: "file_complete",
          value: true,
          netType: "bool",
          comparisonOperator: "=",
          logicalOperator: "AND"
        }],
        defaultFilter: [],
        sortColumns: [],
        distinctColumns: []
      }
    }).set("gm_session_id", gmSessionId()).then(function (res) {
      return res.body;
    }).then(function (res) {}).catch(function (e) {
      console.error("hell no");
    });
  };

  DigiThemeForm.prototype.getFormColumns = function getFormColumns(groupedFields) {
    var _this2 = this;

    var digiTheme = this.props.digiTheme;

    var groupCounter = 0;
    var currentGroup = void 0;
    return digiTheme.columns.map(function (c) {
      var parent = null;
      if (groupedFields && groupedFields.length > 0 && groupedFields[groupCounter] && groupedFields[groupCounter].firstItem === c.column_name) {
        currentGroup = "group_" + (groupCounter + 1);
        parent = currentGroup;
        groupCounter++;
      }

      var dataType = dataTypeDict[c.data_type];
      var type = dataTypeFieldTypeDict[dataType];
      if (type === "uuidArrayField" && c.column_name === "_acl") type = "aclField";
      return _this2.configureField({
        type: type,
        name: c.column_name,
        label: c.name,
        visible: c.visible_editor === "show",
        required: c.required,
        readOnly: !c.editable || !_this2.isEditableDataType(dataType),
        config: _this2.getFieldConfig(c.config),
        parent: parent
      }, c.raw_dictionary);
    });
  };

  DigiThemeForm.prototype.isEditableDataType = function isEditableDataType(dataType) {
    switch (dataType) {
      case "serial":
      case "datetime":
      case "uuid":
      case "foreign_key":
        return false;
    }
    return true;
  };

  DigiThemeForm.prototype.configureField = function configureField(field, rawDictionary) {
    var digiTheme = this.props.digiTheme;

    switch (field.type) {
      case "multiselectListField":
        field.value = [];
      case "editableListField":
      case "listField":
        field.items = rawDictionary.split(field.config.listSeparator || ",");
        break;
      case "dictionaryField":
        field.dictionaryConfig = {
          uuid: field.config.dictDatasource,
          keyColumn: field.config.dictKeyColumn,
          valueColumn: field.config.dictValueColumn,
          geomColumn: field.config.dictGeomColumn,
          copyGeom: field.config.dictCopyGeom,
          zoomToGeom: field.config.dictZoomToGeom
        };
        field.isDictionary = true;
        break;
      case "multiselectDictionaryField":
        field.value = [];
        field.dictionaryConfig = {
          uuid: field.config.dictDatasource,
          keyColumn: field.config.dictKeyColumn,
          valueColumn: field.config.dictValueColumn
        };
        field.isDictionary = true;
        break;
      case "geometryField":
        field.label = "";
        if (field.name === "geom") {
          field.geometryType = digiTheme.spatial_data_type;
          field.name = "geom_wkt";
          break;
        } else {
          var geometryType = spatialDataTypeDict[field.config.geomType];
          if (field.config.geomType && !geometryType) {
            break;
          }
          field.geometryType = geometryType || digiTheme.spatial_data_type;
          break;
        }
    }
    return field;
  };

  DigiThemeForm.prototype.getFieldConfig = function getFieldConfig(config) {
    if (!(config && config.configs && config.configs.length > 0)) return {};

    var configObj = keyValueArrayToObject(config.configs);
    var fixedConfig = {};

    for (var _iterator = Object.entries(configObj), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref2 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref2 = _i.value;
      }

      var _ref = _ref2;
      var key = _ref[0];
      var value = _ref[1];

      switch (key) {
        case "dependency":
          {
            fixedConfig[key] = JSON.parse(value);
            break;
          }
        case "max_length":
          {
            fixedConfig["maxLength"] = parseInt(value);
            break;
          }
        case "min_length":
          {
            fixedConfig["minLength"] = parseInt(value);
            break;
          }
        case "min_value":
          {
            fixedConfig["minValue"] = parseFloat(value);
            break;
          }
        case "max_value":
          {
            fixedConfig["maxValue"] = parseFloat(value);
            break;
          }
        case "decimals":
          {
            fixedConfig["decimals"] = parseInt(value);
            break;
          }
        case "regex":
          {
            fixedConfig[key] = value;
            break;
          }
        case "list_separator":
          fixedConfig["listSeparator"] = value;
          break;
        case "dict_data_source":
          fixedConfig["dictDatasource"] = value;
          break;
        case "dict_key_column":
          fixedConfig["dictKeyColumn"] = value;
          break;
        case "dict_value_column":
          fixedConfig["dictValueColumn"] = value;
          break;
        case "dict_geom_column":
          fixedConfig["dictGeomColumn"] = value;
          break;
        case "dict_zoom_to_geom":
          fixedConfig["dictZoomToGeom"] = value;
          break;
        case "dict_copy_geom":
          fixedConfig["dictCopyGeom"] = value;
          break;
        case "geom_type":
          fixedConfig["geomType"] = value;
          break;

        // _acl configs
        case "allowed_roles":
          fixedConfig["allowedRoles"] = value ? JSON.parse(value) : [];
          break;
        case "single":
          fixedConfig["single"] = value ? JSON.parse(value) : false;
          break;

        default:
          console.warn("Unhandled column config", key, value);
      }
    }
    return fixedConfig;
  };

  DigiThemeForm.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.digiTheme && state.initialRecord !== props.record) {
      return {
        initialRecord: props.record,
        record: DigiThemeForm.formatRecordValues(props.record || {}, props.digiTheme.columns),
        groupedFields: getJsonConfig(props.digiTheme.config.configs, "groupedFields")
      };
    }

    return null;
  };

  DigiThemeForm.prototype.render = function render() {
    var _props2 = this.props,
        digiTheme = _props2.digiTheme,
        displayForm = _props2.displayForm,
        formState = _props2.formState,
        saving = _props2.saving,
        loading = _props2.loading,
        handleField = _props2.handleField,
        onDictionaryItemSelect = _props2.onDictionaryItemSelect,
        onSave = _props2.onSave,
        onCancel = _props2.onCancel,
        lang = _props2.lang;
    var _state = this.state,
        record = _state.record,
        groupedFields = _state.groupedFields;


    return React.createElement(Form, {
      themeUuid: digiTheme.theme_uuid,
      columns: this.getFormColumns(groupedFields),
      fieldsets: groupedFields,
      initialValues: record,
      formState: formState,
      displayForm: displayForm,
      onSave: onSave && this.handleSave,
      onCancel: onCancel && this.handleCancel,
      onChange: this.handleChange,
      onDictionaryItemSelect: onDictionaryItemSelect,
      loading: loading,
      saving: saving,
      handleField: handleField,
      geometryType: digiTheme.spatial_data_type,
      lang: lang
    });
  };

  return DigiThemeForm;
}(Component);

DigiThemeForm.propTypes = process.env.NODE_ENV !== "production" ? {
  record: PropTypes.object,
  digiTheme: PropTypes.object.isRequired,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  onChange: PropTypes.func,
  handleField: PropTypes.func,
  saving: PropTypes.bool,
  loading: PropTypes.bool,
  displayForm: PropTypes.bool
} : {};


export default DigiThemeForm;